import React, { useEffect, useRef, useState } from "react";
import { Box, IconButton, Stack } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import SearchProduct from "../AdminProducts/Products/SearchProduct";
import ModalDetail from "./ModalDetail.js";
import { useDashboardTheme } from "../../../context/DashboardThemeContext";
import { useAlert } from "../../../context/AlertContext";

export default function ProductDetail({ onAddDetail, disabled = false }) {
  const { dashboardTheme } = useDashboardTheme();
  const { showError } = useAlert();
  const token = localStorage.getItem("accessToken");
  const productsAreaRef = useRef(null);
  const [sabores, setSabores] = useState([]);
  const [frutas, setFrutas] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const loadComplementos = async () => {
    try {
      const [saboresResponse, frutasResponse] = await Promise.all([
        fetch("/api/ventas/sabores/?activo=true", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        fetch("/api/ventas/frutas/?activo=true", {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      const [saboresData, frutasData] = await Promise.all([
        saboresResponse.json(),
        frutasResponse.json(),
      ]);
      if (!saboresResponse.ok) {
        showError(saboresData.error || saboresData.detail || "No se pudieron cargar los sabores");
        return;
      }
      if (!frutasResponse.ok) {
        showError(frutasData.error || frutasData.detail || "No se pudieron cargar las frutas");
        return;
      }
      setSabores(saboresData.results || []);
      setFrutas(frutasData.results || []);
    } catch {
      showError("Error de conexión cargando sabores y frutas");
    }
  };

  useEffect(() => {
    loadComplementos();
  }, []);

  const openProduct = (product) => {
    if (disabled) return;
    setSelectedProduct(product);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedProduct(null);
  };

  const scrollProducts = (direction) => {
    const container = productsAreaRef.current;
    if (!container) return;
    const target =
      container.querySelector(".MuiGrid-container") ||
      container.querySelector('[role="list"]') ||
      container;
    target.scrollBy({
      left: direction * Math.max(260, target.clientWidth * 0.7),
      behavior: "smooth",
    });
  };

  return (
    <Box>
      <Stack
        direction="row"
        spacing={0.8}
        justifyContent="flex-end"
        sx={{ mb: 1 }}
      >
        <IconButton
          size="small"
          onClick={() => scrollProducts(-1)}
          disabled={disabled}
          sx={{
            width: 34,
            height: 34,
            borderRadius: "10px",
            border: `1px solid ${dashboardTheme.border_color}`,
            color: dashboardTheme.button_color,
          }}
        >
          <ArrowBackIosNewRoundedIcon sx={{ fontSize: 17 }} />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => scrollProducts(1)}
          disabled={disabled}
          sx={{
            width: 34,
            height: 34,
            borderRadius: "10px",
            border: `1px solid ${dashboardTheme.border_color}`,
            color: dashboardTheme.button_color,
          }}
        >
          <ArrowForwardIosRoundedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Stack>
      <Box
        ref={productsAreaRef}
        sx={{
          width: "100%",
          overflow: "hidden",
          "& .MuiGrid-container": {
            flexWrap: "nowrap !important",
            overflowX: "auto",
            overflowY: "hidden",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
            pb: 1,
          },
          "& .MuiGrid-container > .MuiGrid-item": {
            flex: {
              xs: "0 0 70% !important",
              sm: "0 0 42% !important",
              md: "0 0 28% !important",
              lg: "0 0 22% !important",
            },
            maxWidth: {
              xs: "70% !important",
              sm: "42% !important",
              md: "28% !important",
              lg: "22% !important",
            },
          },
        }}
      >
        <SearchProduct
          showEcommerceCheck
          onSelectProduct={openProduct}
        />
      </Box>
      <ModalDetail
        open={modalOpen}
        onClose={closeModal}
        product={selectedProduct}
        sabores={sabores}
        frutas={frutas}
        onAddDetail={onAddDetail}
        disabled={disabled}
      />
    </Box>
  );
}